// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/api/organizations/deactivations/firstparty/v4/list_deactivation_reasons.proto

/* oxlint-disable */
import {
  ApiClosingReasonDetailsClosingReasonDetail,
  apiClosingReasonDetailsClosingReasonDetailFromJSON,
  apiClosingReasonDetailsClosingReasonDetailToJSON,
} from "./closing_reason_details";
import {
  ApiClosingReasonCategory,
  apiClosingReasonCategoryFromJSON,
  apiClosingReasonCategoryToJSON,
  ApiClosingReasonSubCategory,
  apiClosingReasonSubCategoryFromJSON,
  apiClosingReasonSubCategoryToJSON,
} from "./closing_reasons";

/** Input type for a deactivation reason item. */
export const ApiDeactivationReasonInputType = {
  /** DEACTIVATION_REASON_INPUT_TYPE_UNSPECIFIED - Unspecified input type. */
  DEACTIVATION_REASON_INPUT_TYPE_UNSPECIFIED: "DEACTIVATION_REASON_INPUT_TYPE_UNSPECIFIED",
  /**
   * radio - Radio button selection.
   */
  radio: "radio",
  /**
   * text - Free text input.
   */
  text: "text",
  /**
   * question - Question section header.
   */
  question: "question",
} as const;

export type ApiDeactivationReasonInputType =
  typeof ApiDeactivationReasonInputType[keyof typeof ApiDeactivationReasonInputType];

export namespace ApiDeactivationReasonInputType {
  export type DEACTIVATION_REASON_INPUT_TYPE_UNSPECIFIED =
    typeof ApiDeactivationReasonInputType.DEACTIVATION_REASON_INPUT_TYPE_UNSPECIFIED;
  export type radio = typeof ApiDeactivationReasonInputType.radio;
  export type text = typeof ApiDeactivationReasonInputType.text;
  export type question = typeof ApiDeactivationReasonInputType.question;
}

export function apiDeactivationReasonInputTypeFromJSON(object: any): ApiDeactivationReasonInputType {
  switch (object) {
    case 0:
    case "DEACTIVATION_REASON_INPUT_TYPE_UNSPECIFIED":
      return ApiDeactivationReasonInputType.DEACTIVATION_REASON_INPUT_TYPE_UNSPECIFIED;
    case 1:
    case "radio":
      return ApiDeactivationReasonInputType.radio;
    case 2:
    case "text":
      return ApiDeactivationReasonInputType.text;
    case 3:
    case "question":
      return ApiDeactivationReasonInputType.question;
    default:
      return ApiDeactivationReasonInputType.DEACTIVATION_REASON_INPUT_TYPE_UNSPECIFIED;
  }
}

export function apiDeactivationReasonInputTypeToJSON(object: ApiDeactivationReasonInputType): string {
  switch (object) {
    case ApiDeactivationReasonInputType.DEACTIVATION_REASON_INPUT_TYPE_UNSPECIFIED:
      return "DEACTIVATION_REASON_INPUT_TYPE_UNSPECIFIED";
    case ApiDeactivationReasonInputType.radio:
      return "radio";
    case ApiDeactivationReasonInputType.text:
      return "text";
    case ApiDeactivationReasonInputType.question:
      return "question";
    default:
      return "DEACTIVATION_REASON_INPUT_TYPE_UNSPECIFIED";
  }
}

/** Parameters for a text-type deactivation reason input. */
export interface ApiDeactivationReasonParameters {
  /** Title for the input field. */
  readonly title?:
    | string
    | null
    | undefined;
  /** Placeholder text for the input field. */
  readonly placeholder?:
    | string
    | null
    | undefined;
  /** Minimum length required for text input. */
  readonly minLength?:
    | number
    | null
    | undefined;
  /** Error message to display on validation failure. */
  readonly error?:
    | string
    | null
    | undefined;
  /** Question associated with the input. */
  readonly question?:
    | string
    | null
    | undefined;
  /** Hint text for the input. */
  readonly hint?: string | null | undefined;
}

/** Leaf-level deactivation reason detail (no children). */
export interface ApiDeactivationReasonDetail {
  /** Key identifying this detail. */
  readonly key: ApiClosingReasonDetailsClosingReasonDetail;
  /** Human-readable label for the detail. */
  readonly label: string;
  /** Input type for this detail item. */
  readonly inputType?:
    | ApiDeactivationReasonInputType
    | null
    | undefined;
  /** Optional parameters for text input validation and display. */
  readonly parameters?: ApiDeactivationReasonParameters | null | undefined;
}

/** Second-level deactivation reason sub-category, containing details. */
export interface ApiDeactivationReasonSubCategory {
  /** Key identifying this sub-category. */
  readonly key: ApiClosingReasonSubCategory;
  /** Human-readable label for the sub-category. */
  readonly label: string;
  /** Optional question prompt displayed before detail selection. */
  readonly question?:
    | string
    | null
    | undefined;
  /** Input type for this sub-category item. */
  readonly inputType?:
    | ApiDeactivationReasonInputType
    | null
    | undefined;
  /** Optional parameters for text input validation and display. */
  readonly parameters?:
    | ApiDeactivationReasonParameters
    | null
    | undefined;
  /** Leaf-level details for this sub-category. */
  readonly items: readonly ApiDeactivationReasonDetail[];
}

/** Top-level deactivation reason category, containing sub-categories. */
export interface ApiDeactivationReasonCategory {
  /** Key identifying this category. */
  readonly key: ApiClosingReasonCategory;
  /** Human-readable label for the category. */
  readonly label: string;
  /** Optional question prompt displayed before sub-category selection. */
  readonly question?:
    | string
    | null
    | undefined;
  /** Input type for this category item. */
  readonly inputType?:
    | ApiDeactivationReasonInputType
    | null
    | undefined;
  /** Optional parameters for text input validation and display. */
  readonly parameters?:
    | ApiDeactivationReasonParameters
    | null
    | undefined;
  /** Sub-categories for this category. */
  readonly items: readonly ApiDeactivationReasonSubCategory[];
}

/**
 * Describes the request to list deactivation reasons.
 *
 * The response is localized and scoped to the organization via the following
 * request headers:
 *   - X-Qonto-Locale: determines the language of labels and copy.
 *   - X-Qonto-Organization-ID: scopes the reasons to the organization.
 */
export interface ApiListDeactivationReasonsRequest {
}

/** Describes the response containing the list of deactivation reasons. */
export interface ApiListDeactivationReasonsResponse {
  /** List of available deactivation reason categories. */
  readonly deactivationReasons: readonly ApiDeactivationReasonCategory[];
}

export const ApiDeactivationReasonParameters: MessageFns<ApiDeactivationReasonParameters> = {
  fromJSON(object: any): ApiDeactivationReasonParameters {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : null,
      placeholder: isSet(object.placeholder) ? globalThis.String(object.placeholder) : null,
      minLength: isSet(object.min_length) ? globalThis.Number(object.min_length) : null,
      error: isSet(object.error) ? globalThis.String(object.error) : null,
      question: isSet(object.question) ? globalThis.String(object.question) : null,
      hint: isSet(object.hint) ? globalThis.String(object.hint) : null,
    };
  },

  toJSON(message: ApiDeactivationReasonParameters): unknown {
    const obj: any = {};
    if (message.title !== undefined && message.title !== null) {
      obj.title = message.title;
    }
    if (message.placeholder !== undefined && message.placeholder !== null) {
      obj.placeholder = message.placeholder;
    }
    if (message.minLength !== undefined && message.minLength !== null) {
      obj.min_length = Math.round(message.minLength);
    }
    if (message.error !== undefined && message.error !== null) {
      obj.error = message.error;
    }
    if (message.question !== undefined && message.question !== null) {
      obj.question = message.question;
    }
    if (message.hint !== undefined && message.hint !== null) {
      obj.hint = message.hint;
    }
    return obj;
  },
};

export const ApiDeactivationReasonDetail: MessageFns<ApiDeactivationReasonDetail> = {
  fromJSON(object: any): ApiDeactivationReasonDetail {
    return {
      key: isSet(object.key)
        ? apiClosingReasonDetailsClosingReasonDetailFromJSON(object.key)
        : ApiClosingReasonDetailsClosingReasonDetail.CLOSING_REASON_DETAIL_UNSPECIFIED,
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      inputType: isSet(object.input_type) ? apiDeactivationReasonInputTypeFromJSON(object.input_type) : null,
      parameters: isSet(object.parameters) ? ApiDeactivationReasonParameters.fromJSON(object.parameters) : null,
    };
  },

  toJSON(message: ApiDeactivationReasonDetail): unknown {
    const obj: any = {};
    if (message.key !== undefined && message.key !== null) {
      obj.key = apiClosingReasonDetailsClosingReasonDetailToJSON(message.key);
    }
    if (message.label !== undefined && message.label !== null) {
      obj.label = message.label;
    }
    if (message.inputType !== undefined && message.inputType !== null) {
      obj.input_type = apiDeactivationReasonInputTypeToJSON(message.inputType);
    }
    if (message.parameters !== undefined && message.parameters !== null) {
      obj.parameters = ApiDeactivationReasonParameters.toJSON(message.parameters);
    }
    return obj;
  },
};

export const ApiDeactivationReasonSubCategory: MessageFns<ApiDeactivationReasonSubCategory> = {
  fromJSON(object: any): ApiDeactivationReasonSubCategory {
    return {
      key: isSet(object.key)
        ? apiClosingReasonSubCategoryFromJSON(object.key)
        : ApiClosingReasonSubCategory.CLOSING_REASON_SUB_CATEGORY_UNSPECIFIED,
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      question: isSet(object.question) ? globalThis.String(object.question) : null,
      inputType: isSet(object.input_type) ? apiDeactivationReasonInputTypeFromJSON(object.input_type) : null,
      parameters: isSet(object.parameters) ? ApiDeactivationReasonParameters.fromJSON(object.parameters) : null,
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => ApiDeactivationReasonDetail.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiDeactivationReasonSubCategory): unknown {
    const obj: any = {};
    if (message.key !== undefined && message.key !== null) {
      obj.key = apiClosingReasonSubCategoryToJSON(message.key);
    }
    if (message.label !== undefined && message.label !== null) {
      obj.label = message.label;
    }
    if (message.question !== undefined && message.question !== null) {
      obj.question = message.question;
    }
    if (message.inputType !== undefined && message.inputType !== null) {
      obj.input_type = apiDeactivationReasonInputTypeToJSON(message.inputType);
    }
    if (message.parameters !== undefined && message.parameters !== null) {
      obj.parameters = ApiDeactivationReasonParameters.toJSON(message.parameters);
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => ApiDeactivationReasonDetail.toJSON(e));
    }
    return obj;
  },
};

export const ApiDeactivationReasonCategory: MessageFns<ApiDeactivationReasonCategory> = {
  fromJSON(object: any): ApiDeactivationReasonCategory {
    return {
      key: isSet(object.key)
        ? apiClosingReasonCategoryFromJSON(object.key)
        : ApiClosingReasonCategory.CLOSING_REASON_CATEGORY_UNSPECIFIED,
      label: isSet(object.label) ? globalThis.String(object.label) : "",
      question: isSet(object.question) ? globalThis.String(object.question) : null,
      inputType: isSet(object.input_type) ? apiDeactivationReasonInputTypeFromJSON(object.input_type) : null,
      parameters: isSet(object.parameters) ? ApiDeactivationReasonParameters.fromJSON(object.parameters) : null,
      items: globalThis.Array.isArray(object?.items)
        ? object.items.map((e: any) => ApiDeactivationReasonSubCategory.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiDeactivationReasonCategory): unknown {
    const obj: any = {};
    if (message.key !== undefined && message.key !== null) {
      obj.key = apiClosingReasonCategoryToJSON(message.key);
    }
    if (message.label !== undefined && message.label !== null) {
      obj.label = message.label;
    }
    if (message.question !== undefined && message.question !== null) {
      obj.question = message.question;
    }
    if (message.inputType !== undefined && message.inputType !== null) {
      obj.input_type = apiDeactivationReasonInputTypeToJSON(message.inputType);
    }
    if (message.parameters !== undefined && message.parameters !== null) {
      obj.parameters = ApiDeactivationReasonParameters.toJSON(message.parameters);
    }
    if (message.items?.length) {
      obj.items = message.items.map((e) => ApiDeactivationReasonSubCategory.toJSON(e));
    }
    return obj;
  },
};

export const ApiListDeactivationReasonsRequest: MessageFns<ApiListDeactivationReasonsRequest> = {
  fromJSON(_: any): ApiListDeactivationReasonsRequest {
    return {};
  },

  toJSON(_: ApiListDeactivationReasonsRequest): unknown {
    const obj: any = {};
    return obj;
  },
};

export const ApiListDeactivationReasonsResponse: MessageFns<ApiListDeactivationReasonsResponse> = {
  fromJSON(object: any): ApiListDeactivationReasonsResponse {
    return {
      deactivationReasons: globalThis.Array.isArray(object?.deactivation_reasons)
        ? object.deactivation_reasons.map((e: any) => ApiDeactivationReasonCategory.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiListDeactivationReasonsResponse): unknown {
    const obj: any = {};
    if (message.deactivationReasons?.length) {
      obj.deactivation_reasons = message.deactivationReasons.map((e) => ApiDeactivationReasonCategory.toJSON(e));
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
